import { platforms } from "@/data/platforms"
import { PlatformCard } from "@/components/common/PlatformCard"

export function PlatformCTA() {
  return (
    <section id="platforms" className="py-24 bg-block-navy">
      <div className="max-w-5xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-16">
          <p className="text-caption text-inverse-ink/60 mb-3">现在开始</p>
          <h2 className="text-heading text-inverse-ink mb-4">
            从哪个入口开始都行
          </h2>
          <p className="text-body text-inverse-ink/70 max-w-xl mx-auto">
            小程序、Web、App 数据实时同步，学习进度跟着你走。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 max-w-4xl mx-auto items-stretch">
          {platforms.map((platform, index) => (
            <PlatformCard
              key={platform.id}
              platform={platform}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
